import { Youtube } from "lucide-react";
import FadeInSection from "../../ui/fade-in-section";
import { SESSIONS_YOUTUBE_URL } from "../../../constants/sessions";

export default function SessionsYoutube() {
  return (
    <section className="pb-14 sm:pb-16 bg-white overflow-hidden">
      <div className="page-container">
        <FadeInSection>
          <div className="home-card rounded-2xl p-7 sm:p-10 flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8">
            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#991B1B]/10 text-[#991B1B] shrink-0">
              <Youtube className="w-8 h-8" aria-hidden />
            </div>
            <div className="flex-1 min-w-0">
              <h2 className="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
                Never miss a session
              </h2>
              <p className="mt-2 text-slate-600 text-[15px] sm:text-base leading-relaxed">
                All recordings are available on our YouTube channel. Subscribe so
                you never miss a new session.
              </p>
            </div>
            <a
              href={SESSIONS_YOUTUBE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 py-3 rounded-xl bg-[#991B1B] hover:bg-[#7F1D1D] text-white font-semibold transition-colors shrink-0"
            >
              <Youtube className="w-5 h-5" aria-hidden />
              Subscribe on YouTube
            </a>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
}
